import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';
import UserForm from './userForm';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import * as Permissions from 'permissions';

class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'EditUser';

        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
    }
    save() {
    	this.props.beginEditUser(this.props.users.tmp_user)
    }
    cancel() {
    	this.props.hideEditUser()
    	this.props.updateFeaturesOwnerType('Role')
    	this.props.clearShowIndividualFeatures()
    }
    deleteUser() {
    	this.props.showDeleteUserPrompt()
    }
    componentWillUpdate(next_props) {
      const next_show = next_props.users.editing_user;
      const curr_show = this.props.users.editing_user;
      if(next_show && !curr_show) {
        $(document).on('keydown', ({ key }) => {
          if(key == 'Enter') {
            this.save();
          }
        });
      }
      else if(!next_show && curr_show) {
        $(document).off('keydown');
      }
    }
    render() {
      return (
        <div className='col-md-12'>
        	<Modal
        	show={this.props.users.editing_user}
        	onHide={this.cancel}
        	dialogClassName='edit-user-modal'
        	bsSize="lg"
        	>
        		<div className="panel panel-primary mb-none">
        			<div className="panel-heading">
        				<h3 className="panel-title">Edit User</h3>
        			</div>
        			<div className="panel-body">
        				<UserForm />
        			</div>
        			<div className="panel-footer">
        				<div className="row">
        					{(() => {
        						if((this.props.users.tmp_user &&
        							(this.props.connection.user._id === this.props.users.tmp_user._id)) ||
        							!this.props.hasPermission('/Account Management/Users/Edit/User Details/')) {
        							return (
        								<div>
	        								<div className="col-xs-12 col-md-2 col-md-offset-8 mb-sm">
				        						<div onClick={this.cancel} className="btn btn-block btn-default">Cancel</div>
				        					</div>
				        					<div className="col-xs-12 col-md-2">
				        						<div onClick={this.save} className="btn btn-block btn-primary">Save</div>
				        					</div>
			        					</div>
        							)
        						}
        						else {
        							return (
        								<div>
        									{(() => {
        										if(this.props.hasPermission(Permissions.DELETE_USERS)) {
        											return (
        												<div>
        													<div className="col-xs-12 col-md-2 col-md-offset-6 mb-sm">
								        						<div onClick={this.deleteUser} className="btn btn-block btn-danger">Delete</div>
								        					</div>
					        								<div className="col-xs-12 col-md-2 mb-sm">
								        						<div onClick={this.cancel} className="btn btn-block btn-default">Cancel</div>
								        					</div>
					        								<div className="col-xs-12 col-md-2">
								        						<div onClick={this.save} className="btn btn-block btn-primary">Save</div>
								        					</div>
        												</div>
        												)
        										}
        										else {
        											return (
        												<div>
        													<div className="col-xs-12 col-md-3 col-md-offset-6 mb-sm">
								        						<div onClick={this.cancel} className="btn btn-block btn-default">Cancel</div>
								        					</div>
					        								<div className="col-xs-12 col-md-3">
								        						<div onClick={this.save} className="btn btn-block btn-primary">Save</div>
								        					</div>
        												</div>
        												)
        										}
        									})()}
			        					</div>
        							)
        						}
        					})()}
        				</div>
        			</div>
        		</div>
        	</Modal>
        </div>
      );
    }
}

var mapStateToProps = function({users, connection}) {
	return {
		users,
		connection
	}
}

export default connect(mapStateToProps, Actions)(EditUser);



// WEBPACK FOOTER //
// ./src/browser/components/users/editUser.js